export default __webpack_public_path__ + "static/media/paLogo.ad1ff2cf.png";